const EN_DATASET = {
  demoMessages: {
    invalidCredentials: "Invalid username or password.",
    registerProfessionalSuccess: "Professional registered successfully!",
    registerClientSuccess: "Client registered successfully!",
    saved: "Saved",
    deleted: "Deleted",
    projectDeletedSuccess: "Project deleted successfully.",
    demoAdTitle: "Demo Ad",
    demoAdDescription: "Demo description",
    submittedProjectTitle: "Demo Submitted Project",
    submittedProjectDescription: "Demo submission.",
    demoNotification: "Demo notification",
    educationDeleted: "Education deleted.",
    experienceDeleted: "Experience deleted.",
  },
  demoUsers: [
    {
      id: 101,
      name: "Aisha Al-Harthy",
      email: "business@demo.devgenius.com",
      role: "client",
      status: "active",
      profile: 1,
      companyDescription: "Product design and digital transformation consultancy.",
      yearsInMarket: "5+",
    },
    {
      id: 202,
      name: "Omar Nasser",
      email: "pro@demo.devgenius.com",
      role: "professional",
      status: "active",
      profile: 2,
    },
    {
      id: 1,
      name: "System Admin",
      email: "admin@demo.devgenius.com",
      role: "admin",
      status: "active",
      profile: 1,
    },
  ],
  demoAds: [
    { ad_id: 1, title: "Launch Faster with DevGenius", description: "Hire verified professionals and deliver projects with confidence." },
    { ad_id: 2, title: "Enterprise-Ready Talent Pool", description: "Browse high-quality profiles with skills, portfolios, and work history." },
    { ad_id: 3, title: "Smart Project Matching", description: "Match project requirements to specialist skills in seconds." },
  ],
  demoSkills: [
    { skill_id: 1, skill_name: "React" },
    { skill_id: 2, skill_name: "Node.js" },
    { skill_id: 3, skill_name: "UI/UX" },
    { skill_id: 4, skill_name: "Python" },
    { skill_id: 5, skill_name: "DevOps" },
    { skill_id: 6, skill_name: "SQL" },
  ],
  demoProfessionals: [
    {
      user_id: 202,
      professional_id: 502,
      name: "Omar Nasser",
      personal_image: "",
      role: "professional",
      profile: 2,
      field_of_study: "Software Engineering",
      institution_name: "Cairo University",
      job_title: "Senior Full-Stack Developer",
      scoreReview: 4.8,
    },
    {
      user_id: 203,
      professional_id: 503,
      name: "Lina Kareem",
      personal_image: "",
      role: "professional",
      profile: 1,
      field_of_study: "Computer Science",
      institution_name: "AUB",
      job_title: "Frontend Architect",
      scoreReview: 4.7,
    },
  ],
  demoProfessionalProjects: [
    {
      professional_project_id: 901,
      user_id: 202,
      professional_id: 502,
      project_title: "Enterprise CRM Dashboard",
      title: "Enterprise CRM Dashboard",
      project_description: "A responsive analytics dashboard for enterprise sales teams.",
      type: "Web Application",
      project_price: "12000",
      completion_date: "2026-02-10",
      skills: "React,Node.js,SQL",
      skills_used: "React,Node.js,SQL",
      encoded_image1: "",
      encoded_image2: "",
      encoded_image3: "",
      encoded_image4: "",
      encoded_image5: "",
      professional_name: "Omar Nasser",
      updated_at: "2026-02-12",
    },
    {
      professional_project_id: 902,
      user_id: 203,
      professional_id: 503,
      project_title: "Design System Portal",
      title: "Design System Portal",
      project_description: "A scalable component portal for product and engineering teams.",
      type: "Frontend Platform",
      project_price: "8000",
      completion_date: "2026-01-04",
      skills: "React,UI/UX",
      skills_used: "React,UI/UX",
      professional_name: "Lina Kareem",
      updated_at: "2026-01-12",
    },
  ],
  demoClientProjects: [
    {
      client_project_id: 301,
      user_id: 101,
      title: "B2B Booking Platform",
      description: "Need a multilingual booking platform for regional service providers.",
      budget_range: "$7,000 - $10,000",
      deadline: "2026-06-30",
      skills: "React,Node.js,SQL",
      type: "Web Platform",
      note: "Priority on scalability and clean UI.",
      client_name: "Aisha Al-Harthy",
      client_description: "Product design and digital transformation consultancy.",
      client_years_in_market: "5+",
      status: "in_progress",
      updated_at: "2026-03-01",
    },
    {
      client_project_id: 302,
      user_id: 101,
      title: "Operations Admin Panel",
      description: "Admin panel for KPI tracking and workflow approvals.",
      budget_range: "$4,000 - $6,000",
      deadline: "2026-05-12",
      skills: "React,UI/UX",
      type: "Internal Tool",
      note: "Role-based access is required.",
      client_name: "Aisha Al-Harthy",
      client_description: "Product design and digital transformation consultancy.",
      client_years_in_market: "5+",
      status: "unassigned",
      updated_at: "2026-02-20",
    },
  ],
  demoNotifications: [
    {
      notification_id: 1,
      user_id: 101,
      type: "project_update",
      message: "Your project B2B Booking Platform received a new proposal.",
      client_project_id: 301,
      project_title: "B2B Booking Platform",
    },
    {
      notification_id: 2,
      user_id: 202,
      type: "assignment",
      message: "You have been shortlisted for Operations Admin Panel.",
      client_project_id: 302,
      project_title: "Operations Admin Panel",
    },
  ],
  demoProfile: {
    personal_image: "",
    transcript_upload1: "",
    transcript_upload2: "",
    transcript_upload3: "",
    transcript_upload4: "",
    transcript_upload5: "",
    education: [
      {
        education_id: 1,
        institution_name: "Cairo University",
        field_of_study: "Software Engineering",
        start_date: "2016-09-01",
        end_date: "2020-07-01",
      },
    ],
    experience: [
      {
        experience_id: 1,
        job_title: "Senior Full-Stack Developer",
        company_name: "Nexus Labs",
        start_date: "2021-01-01",
        end_date: "Present",
        description: "Built enterprise web systems and mentoring teams.",
      },
    ],
  },
  demoTestimonials: [
    { client_name: "Mariam", comment: "Excellent communication and delivery.", rating: 5 },
    { client_name: "Yousef", comment: "Strong technical skills and ownership.", rating: 4 },
  ],
  demoDashboardStats: {
    totalUsers: 120,
    totalProjects: 42,
    totalProfessionals: 57,
    pendingProjects: 8,
  },
  demoUserStats: [
    { name: "Jan", professional: 40, business: 20, admin: 2 },
    { name: "Feb", professional: 45, business: 22, admin: 2 },
    { name: "Mar", professional: 50, business: 25, admin: 2 },
  ],
  demoSkillDistribution: [
    { name: "React", count: 18, totalProjects: 12 },
    { name: "Node.js", count: 15, totalProjects: 10 },
    { name: "UI/UX", count: 12, totalProjects: 8 },
    { name: "SQL", count: 9, totalProjects: 6 },
  ],
  demoProjectStatusStats: [
    { status: "unassigned", count: 10 },
    { status: "in_progress", count: 18 },
    { status: "completed", count: 14 },
  ],
};

const AR_DATASET = {
  demoMessages: {
    invalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة.",
    registerProfessionalSuccess: "تم تسجيل المحترف بنجاح!",
    registerClientSuccess: "تم تسجيل العميل بنجاح!",
    saved: "تم الحفظ",
    deleted: "تم الحذف",
    projectDeletedSuccess: "تم حذف المشروع بنجاح.",
    demoAdTitle: "إعلان تجريبي",
    demoAdDescription: "وصف تجريبي",
    submittedProjectTitle: "مشروع تجريبي مُرسل",
    submittedProjectDescription: "إرسال تجريبي.",
    demoNotification: "إشعار تجريبي",
    educationDeleted: "تم حذف المؤهل الدراسي.",
    experienceDeleted: "تم حذف الخبرة العملية.",
  },
  demoUsers: [
    {
      id: 101,
      name: "عائشة الحارثي",
      email: "business@demo.devgenius.com",
      role: "client",
      status: "active",
      profile: 1,
      companyDescription: "استشارات في تصميم المنتجات والتحول الرقمي.",
      yearsInMarket: "5+",
    },
    {
      id: 202,
      name: "عمر ناصر",
      email: "pro@demo.devgenius.com",
      role: "professional",
      status: "active",
      profile: 2,
    },
    {
      id: 1,
      name: "مسؤول النظام",
      email: "admin@demo.devgenius.com",
      role: "admin",
      status: "active",
      profile: 1,
    },
  ],
  demoAds: [
    { ad_id: 1, title: "أنجز أسرع مع DevGenius", description: "وظّف محترفين موثّقين وأنهِ مشاريعك بثقة." },
    { ad_id: 2, title: "قاعدة مواهب جاهزة للمؤسسات", description: "تصفح ملفات عالية الجودة تتضمن المهارات والأعمال السابقة والخبرات." },
    { ad_id: 3, title: "مطابقة ذكية للمشاريع", description: "طابق متطلبات مشروعك مع المهارات المتخصصة خلال ثوانٍ." },
  ],
  demoSkills: [
    { skill_id: 1, skill_name: "رياكت" },
    { skill_id: 2, skill_name: "Node.js" },
    { skill_id: 3, skill_name: "تصميم واجهات وتجربة المستخدم" },
    { skill_id: 4, skill_name: "بايثون" },
    { skill_id: 5, skill_name: "ديف أوبس" },
    { skill_id: 6, skill_name: "SQL" },
  ],
  demoProfessionals: [
    {
      user_id: 202,
      professional_id: 502,
      name: "عمر ناصر",
      personal_image: "",
      role: "professional",
      profile: 2,
      field_of_study: "هندسة البرمجيات",
      institution_name: "جامعة القاهرة",
      job_title: "مطور متكامل أول",
      scoreReview: 4.8,
    },
    {
      user_id: 203,
      professional_id: 503,
      name: "لينا كريم",
      personal_image: "",
      role: "professional",
      profile: 1,
      field_of_study: "علوم الحاسوب",
      institution_name: "AUB",
      job_title: "معمارية واجهات أمامية",
      scoreReview: 4.7,
    },
  ],
  demoProfessionalProjects: [
    {
      professional_project_id: 901,
      user_id: 202,
      professional_id: 502,
      project_title: "لوحة تحكم CRM للمؤسسات",
      title: "لوحة تحكم CRM للمؤسسات",
      project_description: "لوحة تحليلات تفاعلية لفرق المبيعات في الشركات.",
      type: "تطبيق ويب",
      project_price: "12000",
      completion_date: "2026-02-10",
      skills: "رياكت,Node.js,SQL",
      skills_used: "رياكت,Node.js,SQL",
      encoded_image1: "",
      encoded_image2: "",
      encoded_image3: "",
      encoded_image4: "",
      encoded_image5: "",
      professional_name: "عمر ناصر",
      updated_at: "2026-02-12",
    },
    {
      professional_project_id: 902,
      user_id: 203,
      professional_id: 503,
      project_title: "بوابة نظام التصميم",
      title: "بوابة نظام التصميم",
      project_description: "بوابة قابلة للتوسع للمكونات تخدم فرق المنتج والهندسة.",
      type: "منصة واجهات أمامية",
      project_price: "8000",
      completion_date: "2026-01-04",
      skills: "رياكت,تصميم واجهات وتجربة المستخدم",
      skills_used: "رياكت,تصميم واجهات وتجربة المستخدم",
      professional_name: "لينا كريم",
      updated_at: "2026-01-12",
    },
  ],
  demoClientProjects: [
    {
      client_project_id: 301,
      user_id: 101,
      title: "منصة حجوزات بين الشركات",
      description: "نحتاج منصة حجوزات متعددة اللغات لمزودي الخدمات في المنطقة.",
      budget_range: "$7,000 - $10,000",
      deadline: "2026-06-30",
      skills: "رياكت,Node.js,SQL",
      type: "منصة ويب",
      note: "الأولوية لقابلية التوسع وواجهة مستخدم نظيفة.",
      client_name: "عائشة الحارثي",
      client_description: "استشارات في تصميم المنتجات والتحول الرقمي.",
      client_years_in_market: "5+",
      status: "in_progress",
      updated_at: "2026-03-01",
    },
    {
      client_project_id: 302,
      user_id: 101,
      title: "لوحة إدارة العمليات",
      description: "لوحة تحكم لمتابعة مؤشرات الأداء واعتماد سير العمل.",
      budget_range: "$4,000 - $6,000",
      deadline: "2026-05-12",
      skills: "رياكت,تصميم واجهات وتجربة المستخدم",
      type: "أداة داخلية",
      note: "مطلوب صلاحيات وصول حسب الأدوار.",
      client_name: "عائشة الحارثي",
      client_description: "استشارات في تصميم المنتجات والتحول الرقمي.",
      client_years_in_market: "5+",
      status: "unassigned",
      updated_at: "2026-02-20",
    },
  ],
  demoNotifications: [
    {
      notification_id: 1,
      user_id: 101,
      type: "project_update",
      message: "استلم مشروعك منصة حجوزات بين الشركات عرضًا جديدًا.",
      client_project_id: 301,
      project_title: "منصة حجوزات بين الشركات",
    },
    {
      notification_id: 2,
      user_id: 202,
      type: "assignment",
      message: "تم اختيارك ضمن القائمة القصيرة لمشروع لوحة إدارة العمليات.",
      client_project_id: 302,
      project_title: "لوحة إدارة العمليات",
    },
  ],
  demoProfile: {
    personal_image: "",
    transcript_upload1: "",
    transcript_upload2: "",
    transcript_upload3: "",
    transcript_upload4: "",
    transcript_upload5: "",
    education: [
      {
        education_id: 1,
        institution_name: "جامعة القاهرة",
        field_of_study: "هندسة البرمجيات",
        start_date: "2016-09-01",
        end_date: "2020-07-01",
      },
    ],
    experience: [
      {
        experience_id: 1,
        job_title: "مطور متكامل أول",
        company_name: "نكسس لابز",
        start_date: "2021-01-01",
        end_date: "حتى الآن",
        description: "طوّرت أنظمة ويب مؤسسية وقدّمت الإرشاد لفرق التطوير.",
      },
    ],
  },
  demoTestimonials: [
    { client_name: "مريم", comment: "تواصل ممتاز وتسليم احترافي.", rating: 5 },
    { client_name: "يوسف", comment: "مهارات تقنية قوية وتحمل للمسؤولية.", rating: 4 },
  ],
  demoDashboardStats: {
    totalUsers: 120,
    totalProjects: 42,
    totalProfessionals: 57,
    pendingProjects: 8,
  },
  demoUserStats: [
    { name: "يناير", professional: 40, business: 20, admin: 2 },
    { name: "فبراير", professional: 45, business: 22, admin: 2 },
    { name: "مارس", professional: 50, business: 25, admin: 2 },
  ],
  demoSkillDistribution: [
    { name: "رياكت", count: 18, totalProjects: 12 },
    { name: "Node.js", count: 15, totalProjects: 10 },
    { name: "تصميم واجهات وتجربة المستخدم", count: 12, totalProjects: 8 },
    { name: "SQL", count: 9, totalProjects: 6 },
  ],
  demoProjectStatusStats: [
    { status: "unassigned", count: 10 },
    { status: "in_progress", count: 18 },
    { status: "completed", count: 14 },
  ],
};

export const DEMO_DATASETS = {
  en: EN_DATASET,
  ar: AR_DATASET,
};

export const getCurrentDemoLanguage = () => {
  const stored = (localStorage.getItem("devgenius_language") || "").toLowerCase();
  if (stored.startsWith("ar")) return "ar";
  if (stored.startsWith("en")) return "en";
  const htmlLang = (document.documentElement.lang || "").toLowerCase();
  return htmlLang.startsWith("ar") ? "ar" : "en";
};

export const getDemoData = (language = "en") => DEMO_DATASETS[language] || DEMO_DATASETS.en;

export const demoUsers = EN_DATASET.demoUsers;
export const demoAds = EN_DATASET.demoAds;
export const demoSkills = EN_DATASET.demoSkills;
export const demoProfessionals = EN_DATASET.demoProfessionals;
export const demoProfessionalProjects = EN_DATASET.demoProfessionalProjects;
export const demoClientProjects = EN_DATASET.demoClientProjects;
export const demoNotifications = EN_DATASET.demoNotifications;
export const demoProfile = EN_DATASET.demoProfile;
export const demoTestimonials = EN_DATASET.demoTestimonials;
export const demoDashboardStats = EN_DATASET.demoDashboardStats;
export const demoUserStats = EN_DATASET.demoUserStats;
export const demoSkillDistribution = EN_DATASET.demoSkillDistribution;
export const demoProjectStatusStats = EN_DATASET.demoProjectStatusStats;
